export enum IdentificationType {
    DRIVING_LICENSE = "Driving License",
    NATIONAL_ID = "National Id", 
    PASSPORT = "Passport",
    REFUGEE_ID = "Refugee Id",
    FOREIGNER_ID = "Foreigner Id",
    REGISTRATION_NUMBER = "Registration Number"
}
